<template>
  <div class="footer-container">
    <div class="buttons-container">
      <mobialis-button
        @click="applyNow()"
        v-av-analytics-cta-interaction="{
          elementText: $t('message.credit.inventoryMatching.applyNow'),
          eventActionResult: 'open',
        }"
      >
        {{ $t('message.credit.inventoryMatching.applyNow') }}
      </mobialis-button>
      <mobialis-button
        @click="back()"
        class="mt-2"
        variant="link"
        v-av-analytics-cta-interaction="{
          elementText: $t('message.credit.inventoryMatching.back'),
          eventActionResult: 'open',
        }"
      >
        {{ $t('message.credit.inventoryMatching.back') }}
      </mobialis-button>
    </div>
    <div class="vehicle-info-container">
      <div class="row align-items-center">
        <div class="col">
          <h5 class="m-0 vehicle-name" data-test="vehicleName">{{ vehicleName }}</h5>
        </div>
        <div class="col-auto vehicle-price text-right" data-test="vehiclePrice">
          {{ $n(vehicleData.paymentMonthly, 'currencyDollars', languageCode)
          }}{{ $t('message.credit.inventoryMatching.perMonth') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import helperFunctions from '@/utils/helperFunctions';

export default {
  name: 'VehicleInfoFooter',
  computed: {
    ...mapGetters({
      languageCode: 'user/getLanguageCodeForNumericalInternationalization',
    }),
    vehicleData() {
      return this.$store.state.credit.matchedInventoryResults.matchedVehicles.filter(
        vehicle => vehicle.id === this.$route.params.id
      )[0];
    },
    vehicle() {
      return this.vehicleData.vehicle;
    },
    vehicleName() {
      return helperFunctions.getVehicleName(this.vehicle, ['year', 'make', 'model', 'trim']);
    },
  },
  methods: {
    applyNow() {
      const payload = {
        elementInteractedWith: 'cim.applyForFinancingStart',
        vehicleId: this.vehicleData.id,
      };
      this.goToAVFinanceFlow(this.vehicleData);
      this.$store.dispatch('metrics/logModalInteraction', payload).catch(error => {
        this.$log('Error in logging interaction', error);
      });
    },
    back() {
      this.$router.push({
        name: `credit-results-${this.baseRoute}`,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';

.footer-container {
  background-color: #ffffff;
  bottom: 0;
  left: 0;
  position: fixed;
  width: 100%;
  z-index: 1050;
}

.buttons-container {
  max-width: 751px;
  padding: 15px;
  margin: 0 auto;
}

.vehicle-info-container {
  padding: 20px 5%;
  background-color: #ffffff;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
}

.vehicle-price {
  color: $primary;
  font-size: 20px;
  font-style: normal;
  line-height: 20px;
  font-weight: 500;
  @media (max-width: $breakpoint-mobile) {
    font-size: 16px;
    line-height: 20px;
  }
}

.vehicle-name {
  @media (max-width: $breakpoint-mobile) {
    font-size: 14px;
    line-height: 17.5px;
  }
}
</style>
